/**
 *
 */
export const PUBLIC_KEY = 'auth.route.public';
export const DEFAULT_PAGING_SIZE = 10;
